import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IMaladieAccident, IGetOneMaladie, IGetAllMaladie } from './imaladie';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class MaladieService {
  private _url:string = '/api/Agenda/';
  constructor(private _http: HttpClient) { }

  setMaladie(maladie: IMaladieAccident): Observable<IMaladieAccident>{
    return this._http.post<IMaladieAccident>(this._url + "InjecterMaladie/", maladie)
  }

  getOneMaladie(cle: number):Observable<IGetOneMaladie>{
    return this._http.get<IGetOneMaladie>(this._url + "MaladieAccident/" + cle).pipe(map(
      resp => {
        return resp;
      }
    ))
  }

  deleteMaladie(cle: number):Observable<IMaladieAccident>{
    return this._http.delete<IMaladieAccident>(this._url + "MaladieAccident/" + cle).pipe(map(
      resp => {
        return resp;
      }
    ))
  }


}
